(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ekodart-header"]) return;
  try {
    
  if (!customElements.get('ekd-header')) {
    class EkdHeader extends HTMLElement {
      constructor() {
        super();
        this.drawerOpen = false;
        this.closeTimer = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onResize = this.onResize.bind(this);
      }

      connectedCallback() {
        this.bar = this.querySelector('[data-bar]');
        this.drawer = this.querySelector('[data-drawer]');
        this.openBtn = this.querySelector('[data-menu-open]');
        this.searchBtn = this.querySelector('[data-search-toggle]');
        this.searchPanel = this.querySelector('[data-search]');
        this.searchInput = this.querySelector('[data-search-input]');

        if (this.openBtn && this.drawer) {
          this.openBtn.addEventListener('click', () => this.openDrawer());
          this.drawer.addEventListener('click', (e) => {
            if (e.target.closest && e.target.closest('[data-menu-close]')) this.closeDrawer();
            else if (e.target.closest && e.target.closest('a[href]')) this.closeDrawer(true);
          });
        }

        if (this.searchBtn && this.searchPanel) {
          this.searchBtn.addEventListener('click', () => this.toggleSearch());
          this.searchPanel.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') { e.preventDefault(); this.toggleSearch(false); this.searchBtn.focus(); }
          });
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('keydown', this.onKey);
        document.documentElement.classList.remove('ekd-hd-lock');
        clearTimeout(this.closeTimer);
      }

      onScroll() {
        if (!this.bar) return;
        this.bar.classList.toggle('is-scrolled', (window.scrollY || window.pageYOffset) > 4);
      }

      onResize() {
        if (this.drawerOpen && window.innerWidth >= 990) this.closeDrawer(true);
      }

      /* Menu drawer */
      openDrawer() {
        if (this.drawerOpen || !this.drawer) return;
        clearTimeout(this.closeTimer);
        this.toggleSearch(false);
        this.drawerOpen = true;
        this.lastFocus = document.activeElement;
        this.drawer.hidden = false;
        void this.drawer.offsetWidth;
        this.drawer.classList.add('is-open');
        document.documentElement.classList.add('ekd-hd-lock');
        document.addEventListener('keydown', this.onKey);
        const first = this.drawer.querySelector('.ekd-hd__panel-head button');
        if (first) first.focus();
      }

      closeDrawer(skipFocus) {
        if (!this.drawerOpen) return;
        this.drawerOpen = false;
        this.drawer.classList.remove('is-open');
        document.documentElement.classList.remove('ekd-hd-lock');
        document.removeEventListener('keydown', this.onKey);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.closeTimer = setTimeout(() => { this.drawer.hidden = true; }, reduce ? 0 : 260);
        if (!skipFocus && this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
      }

      onKey(e) {
        if (!this.drawerOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); this.closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        const nodes = Array.prototype.slice.call(
          this.drawer.querySelectorAll('.ekd-hd__panel a[href], .ekd-hd__panel button, .ekd-hd__panel summary')
        ).filter((el) => el.getClientRects().length);
        if (!nodes.length) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        const active = document.activeElement;
        if (e.shiftKey && (active === first || !this.drawer.contains(active))) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && (active === last || !this.drawer.contains(active))) {
          e.preventDefault();
          first.focus();
        }
      }

      /* Search */
      toggleSearch(force) {
        if (!this.searchPanel || !this.searchBtn) return;
        const open = typeof force === 'boolean' ? force : this.searchPanel.hidden;
        this.searchPanel.hidden = !open;
        this.searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && this.searchInput) this.searchInput.focus();
      }
    }
    customElements.define('ekd-header', EkdHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
